import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { ReceiptFormTypes } from "models/formTypes";
import { ReceiptTodoSelectionFormViewProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import { useWintExpandableStep, useWintForm, WintForm } from "components/common/wintForms";
import { useCostForwardingFormSync } from "components/costForwardingMarking";
import ReceiptTodoCategorySection from "./sections/todoCategorySection";
import ReceiptTodoFileUploaderSection from "./sections/todoFileUploaderSection";
import ReceiptTodoManualPaymentSection from "./sections/todoManualPaymentSection";
import ReceiptTodoPaymentSection from "./sections/todoPaymentSection";
import ReceiptTodoDimensionSection from "./sections/todoDimensionSection";
import ReceiptTodoCostForwardingSection from "./sections/todoCostForwardingSection";
import { Grid } from "@mui/material";
import cssExports from "theme/styles/main.module.scss";
//#endregion

const ReceiptTodoSelectionForm: ForwardRefRenderFunction<FormHandles, ReceiptTodoSelectionFormViewProps> = (
  props,
  ref
) => {
  const {
    receipt,
    defaultValues,
    validationSchema,
    handleSubmit,
    fileViewer,
    showFullForm,
    onUploadedFilesChangeHandler,
    receiptCategoryChangeHandler,
    receiptManualPaymentChangeHandler,
    onFormUpdate,
  } = props;

  const { wintFormProps, connect, values, formState } = useWintForm<ReceiptFormTypes.Todo>({
    formRef: ref,
    defaultValues: defaultValues,
    validationSchema: validationSchema,
    handleSubmit: handleSubmit,
    enableReinitialize: true,
    onFormUpdate: onFormUpdate,
  });

  const expandableStepProps = useWintExpandableStep(formState);
  useCostForwardingFormSync(formState.setValues);

  return (
    <WintForm {...wintFormProps}>
      <Grid container className={cssExports.sectionedForm}>
        {showFullForm && (
          <ReceiptTodoFileUploaderSection
            connect={connect}
            onChange={onUploadedFilesChangeHandler}
            expandableStepProps={expandableStepProps}
          />
        )}
        <ReceiptTodoCategorySection
          connect={connect}
          receiptCategoryChangeHandler={receiptCategoryChangeHandler}
          expandableStepProps={expandableStepProps}
        />
        {(showFullForm || receipt.isOtherPaymentMethod) && (
          <ReceiptTodoPaymentSection receipt={receipt} connect={connect} expandableStepProps={expandableStepProps} />
        )}
        {values.showDimensions && (
          <ReceiptTodoDimensionSection
            connect={connect}
            expandableStepProps={expandableStepProps}
            fileViewer={fileViewer}
            values={values}
          />
        )}
        {!values.canPayEmployee && (
          <ReceiptTodoManualPaymentSection
            connect={connect}
            onChangeHandler={receiptManualPaymentChangeHandler}
            expandableStepProps={expandableStepProps}
          />
        )}
        {values.costForwardingAvailable && (
          <ReceiptTodoCostForwardingSection
            connect={connect}
            values={values}
            expandableStepProps={expandableStepProps}
          />
        )}
      </Grid>
    </WintForm>
  );
};

export default forwardRef(ReceiptTodoSelectionForm);
